import { ClassKey } from "@const/class.constants";

export const LPAR = [ClassKey.VIRTUALIZATION, ClassKey.DATABASE, ClassKey.CONTAINER, ClassKey.CLOUD, ClassKey.BACKUP, ClassKey.SERVERSP, ClassKey.TAPE] as const;
export const STOR = [ClassKey.STORAGE, ClassKey.SAN, ClassKey.LAN] as const;

export type ClassType = typeof ClassKey[keyof typeof ClassKey];

export function isClassLPAR(cls: string) {
  return (LPAR as readonly string[]).includes(cls);
}

/** Class-level universal groups (LAN, tape across hw types). Tape stays LPAR elsewhere. */
export function isClassGroupMode(cls: string) {
  return (!isClassLPAR(cls) || cls === ClassKey.TAPE) && cls !== ClassKey.SAN;
}

export function isClassSTOR(cls: string) {
  return (STOR as readonly string[]).includes(cls);
}

/** Classes whose item selection binds to a HW type. LAN joined in v2.4; storage and SAN stay class-wide. */
export function isClassWithHwType(cls: string) {
  return isClassLPAR(cls) || cls === ClassKey.LAN;
}

/**
 * LAN selection saved before LAN HW types, i.e. across all LAN technologies.
 * Never matches an unsaved row: a subsystem cannot be picked there without a HW type.
 */
export function isLegacyLanSelection(sel: { class?: string; hw_type?: string; subsystem?: string; } | undefined) {
  return sel?.class === ClassKey.LAN && !sel.hw_type && !!sel.subsystem;
}

export function isClassNetwork(cls: string) {
  return cls === ClassKey.SAN || cls === ClassKey.LAN;
}

/**
 * Classes routed under /:class/type/:segment (SAN, LAN, Tape). The rule lives once, beside the server's
 * own use of it for the links the public API hands out, so the two can never disagree.
 */
export { isClassTypeNav } from "@dto/ui-path";